import './Files.scss';

export const Image = ({ blobUrl }) => {
    return <div
        className="image-preview"
        style={{
            background: `url(${blobUrl})`,
            minWidth: 800,
            minHeight: 800,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            backgroundPosition: 'center center',
        }}/>
};
